import { AdjustmentTypes, getAdjustmentValue } from '@app/evaluation-core'
import Feather from '@ovaeasy/react-native-vector-icons/Feather'
import React, { useEffect, useRef, useState } from 'react'
import { ResetParameterConfirmationModal } from './ResetParameterConfirmationModal'
import { useMediaQuery } from 'react-responsive'
import {
  AdmSectionHeading,
  AdmSectionSeparator,
  AdmSectionSideHeader,
  AdmSectionSideItem,
  AdmSectionSideItemBox,
  AdmSectionSubText,
  Label,
  LabelText,
  ResetAdjustmentButton,
  ResetAdjustmentButtonContent,
  ParameterRowV2,
  ParameterLabelStackV2,
  ParameterLabelV2,
  ParameterSecondaryLabelV2,
  ParameterControlsV2,
  ParameterControlRowV2,
  ParameterControlBoxV2,
  ParameterInputV2,
  ParameterUnitAndResetRowV2,
  ParameterUnitV2,
  ResetAdjustmentGroupV2,
  ResetAdjustmentValueV2,
  ResetAdjustmentButtonV2,
} from './Adjustment.styles'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {
  Eval,
  EvaluationUserView,
  GolferShortName,
  LockStatus,
} from '@app/evaluation-core/types'
import Selector from '@app/ui/Selector'
import { useEvaluation } from '@common/hooks'
import useAdjustment from '@common/hooks/useAdjustment'
import useEvaluationLockedState from '@common/hooks/useEvaluationLockedState'
import useEvaluationUser from '@common/hooks/useEvaluationUser'
import useSetAdjustment from '@common/hooks/useSetAdjustment'
import { originalValueFunctions } from '../helpers'
import { Tweener } from '../tweener'
import { AdmParameter } from '../types'
import TableValue from './TableValue'
import { TableValueSeparator } from './TableValue.styles'
import {
  LoadingContainer,
  LoadingDefaultInputContainerV2,
} from './AdjustmentFactors.styles'
import SideItemSkeleton from './skeletons/SideItemSkeleton'
import OptionalAdjustmentSkeleton from './skeletons/OptionalAdjuatmentSkeleton'
import useModifications from '@common/hooks/useModifications'
import {
  getModification,
  Modifications,
} from '@app/evaluation-core/modifications'

interface AdmParameterItemProps {
  param: AdmParameter
  lz?: number
}
type Input = React.InputHTMLAttributes<HTMLInputElement>

function adjustViewTeeIndexes(
  evaluation: Eval,
  view: EvaluationUserView
): EvaluationUserView {
  const currentTee = evaluation.holes[view.hole].tees[view.tee]
  const currentShots = currentTee.shots[view.golfer] ?? []
  const currentApproachShot = currentShots.at(-1)

  const shot =
    view.shot === currentApproachShot?.shotIndex
      ? currentApproachShot.shotIndex
      : view.shot

  const newView: EvaluationUserView = {
    ...view,
    tee: currentTee.teeIndex,
    shot,
  }

  return newView
}

export const AdmParameterItem = (props: AdmParameterItemProps) => {
  const adjustments = useAdjustment()
  const lockStatus = useEvaluationLockedState()
  const [setAdjustment] = useSetAdjustment()

  const { currentId, evaluation } = useEvaluation()
  const { view: view2 } = useEvaluationUser()
  const view: EvaluationUserView = adjustViewTeeIndexes(evaluation, view2)

  const item = getAdjustmentValue(
    props.param.format as any,
    view,
    props.param.adjustmentKey as string,
    adjustments
  ) as number

  const [inputValue, setInputValue] = useState<number | string>(item)
  const inputRef = useRef<Input>()

  const isLargeScreen = useMediaQuery({ query: '(min-width: 1900px)' })

  const getOriginalValue = (key: string) => {
    const fn = originalValueFunctions[key]
    if (typeof fn === 'function') {
      return fn({
        view,
        adjustments,
        defaultCourseSettings: evaluation.defaultCourseSettings,
      })
    }
    return undefined
  }

  useEffect(() => {
    if (item !== inputValue) {
      if (inputRef.current) {
        inputRef.current.value = item
      }
      setInputValue(item)
    }
  }, [item, lockStatus])

  const type = props.param.type ?? 'stepper-input'

  const modifications = useModifications()

  const updateAllApproachShots = (value: number) => {
    for (const teeObj of Object.values(evaluation.holes[view.hole].tees)) {
      for (const [golfer, shots] of Object.entries(teeObj.shots)) {
        const approachShot = shots[shots.length - 1]
        if (approachShot) {
          const newView: EvaluationUserView = {
            ...view,
            golfer: golfer as GolferShortName,
            shot: approachShot.shotIndex,
            tee: teeObj.teeIndex,
          }
          let modType = Modifications.AUTOMATIC
          console.log('VIEW2', view)

          if (
            view.golfer === golfer &&
            view.tee === teeObj.teeIndex &&
            view.shot === approachShot.shotIndex &&
            view.hole === view.hole
          ) {
            console.log('VIEW', view)
            modType = Modifications.ADJUSTED
          }
          const shouldUpdateModification = true
          setAdjustment(
            props.param.format as AdjustmentTypes,
            newView,
            props.param.adjustmentKey as string,
            currentId as string,
            value,
            shouldUpdateModification,
            modType
          )
        }
      }
    }
  }

  //Todo: Hacked togheter. Fix and export.
  const setUpdateToAllApproachShots = (target: any) => {
    console.log({ target })
    console.log('tees', evaluation.holes[view.hole].tees)
    for (const teeObj of Object.values(evaluation.holes[view.hole].tees)) {
      for (const [golfer, shots] of Object.entries(teeObj.shots)) {
        console.log({ golfer, shots })
        const approachShot = shots[shots.length - 1]
        if (approachShot) {
          for (const teeObj of Object.values(
            evaluation.holes[view.hole].tees
          )) {
            try {
              const newView: EvaluationUserView = {
                ...view,
                golfer: golfer as GolferShortName,
                shot: shots.length - 1,
                tee: teeObj.teeIndex,
              }

              const modificationType = getModification(
                modifications,
                view.adjustment as number,
                {
                  tee: teeObj.teeIndex,
                  shot: shots.length - 1,
                  golfer: golfer as GolferShortName,
                },
                false
              )

              const shouldUpdateModification =
                modificationType !== Modifications.CONFIRMED

              // if is the interacted parameter then it should be Modification.ADJUSTED
              // if is not the interacted parameter then it should be Modification.AUTOMATIC

              let modType = Modifications.AUTOMATIC

              if (
                view.golfer === golfer &&
                view.tee === teeObj.teeIndex &&
                view.shot === shots.length - 1 &&
                view.hole === view.hole
              ) {
                modType = Modifications.ADJUSTED
              }

              console.log({
                newView,
                key: props.param.adjustmentKey,
                currentId: currentId,
                value: +target.value,
                shouldUpdateModification: shouldUpdateModification,
                modType: modType,
              })
              //TODO: Batch update instead of loop through
              setAdjustment(
                props.param.format as AdjustmentTypes,
                newView,
                props.param.adjustmentKey as string,
                currentId as string,
                +target.value,
                shouldUpdateModification,
                modType
              )
            } catch (error) {
              console.log({ error })
            }
          }
        }
      }
    }
  }

  const getInputComponent = () => {
    const { inputDisabled, inputType, selectorLabels, selectorValues } =
      props.param
    const canEdit = lockStatus === LockStatus.UNLOCKED

    switch (type) {
      case 'select':
        if (!selectorValues) return

        const setValue = (value) => {
          if (lockStatus !== LockStatus.LOCKED) {
            setInputValue(value)
          }
          setAdjustment(
            props.param.format as AdjustmentTypes,
            view,
            props.param.adjustmentKey as string,
            currentId as string,
            value
          )
          if (lockStatus === LockStatus.LOCKED && inputRef.current) {
            if (inputRef.current) {
              inputRef.current.value = item
            }
          }
        }

        return (
          <>
            <ParameterControlBoxV2>
              <Selector
                setValue={setValue}
                values={selectorValues}
                labels={selectorLabels}
                currentValue={inputValue}
                preserveOrder={props.param.selectorPreserveOrder}
              />
            </ParameterControlBoxV2>
            {props.param.showValue && (
              <ParameterInputV2
                isReadonly={true}
                disabled={true}
                type="number"
                value={inputValue}
                readOnly
              />
            )}
          </>
        )
      default:
        const onChange = ({ target }) => {
          if (lockStatus !== LockStatus.LOCKED) {
            setInputValue(+target.value)
          }

          const shots =
            evaluation.holes[view.hole].tees[view.tee].shots[view.golfer]
          const approachShot = shots?.[shots.length - 1]
          const isApproachShot =
            !!approachShot &&
            approachShot.shotIndex === shots?.[view.shot].shotIndex

          if (
            props.param.applyToAllApproachShots &&
            isApproachShot &&
            evaluation.clubId !== 394 // Temp disabled for this club until fixed in liveCR. Issue was removed first tee screwed up the indexing
          ) {
            updateAllApproachShots(+target.value)
          } else {
            console.log({
              view,
              adjustmentKey: props.param.adjustmentKey,
              currentId,
              value: +target.value,
            })
            setAdjustment(
              props.param.format as AdjustmentTypes,
              view,
              props.param.adjustmentKey as string,
              currentId as string,
              +target.value
            )
          }

          if (lockStatus === LockStatus.LOCKED && inputRef.current) {
            inputRef.current.value = item
          }
        }

        if (inputDisabled) {
          return (
            <ParameterControlBoxV2>
              {!adjustments || !adjustments.adjustments ? (
                <LoadingDefaultInputContainerV2 isReadOnly={true}>
                  <LoadingContainer>
                    <Feather name="loader" size={16} />
                  </LoadingContainer>
                </LoadingDefaultInputContainerV2>
              ) : (
                <ParameterInputV2
                  isReadonly={inputDisabled}
                  disabled={!canEdit}
                  type={inputType ?? 'number'}
                  value={inputValue}
                />
              )}
            </ParameterControlBoxV2>
          )
        }
        return (
          <ParameterControlBoxV2>
            {!adjustments || !adjustments.adjustments ? (
              <LoadingDefaultInputContainerV2 isReadOnly={false}>
                <LoadingContainer>
                  <Feather name="loader" size={16} />
                </LoadingContainer>
              </LoadingDefaultInputContainerV2>
            ) : (
              <ParameterInputV2
                // @ts-ignore
                ref={inputRef}
                onFocus={(event) => event.target.select()}
                isReadonly={inputDisabled}
                disabled={!canEdit}
                type={inputType ?? 'number'}
                defaultValue={inputValue}
                onChange={({ target }) => setInputValue(+target.value)}
                onBlur={onChange}
              />
            )}
          </ParameterControlBoxV2>
        )
    }
  }

  const getOriginalValueComponent = (useV2 = false) => {
    if (!props.param.adjustmentKey) {
      return null
    }
    const originalValue = getOriginalValue(props.param.adjustmentKey)
    if (!originalValue || originalValue === '') {
      return null
    }
    return (
      <OriginalValueComponent
        param={props.param}
        originalValue={originalValue}
        lockStatus={lockStatus}
        setAdjustment={setAdjustment}
        view={view}
        currentId={currentId}
        useV2={useV2}
      />
    )
  }
  const parametersSkeleton = (!props || !props.param || !view) && (
    <Skeleton
      width={60}
      style={{
        marginBottom: 16,
        minHeight: 16,
      }}
    />
  )
  return (
    <>
      {parametersSkeleton}
      {props.param.type === 'label' && (
        <Label>
          <LabelText>{props.param.label}</LabelText>
        </Label>
      )}
      {parametersSkeleton}
      {!props.param && <TableValueSeparator />}
      {props.param.type === 'table-value' && (
        <>
          <TableValueSeparator />
          <TableValue value={item} label={props.param.label} />
        </>
      )}
      {parametersSkeleton}
      {props.param.type !== 'table-value' && props.param.type !== 'label' && (
        <ParameterRowV2>
          <ParameterLabelStackV2>
            <ParameterLabelV2>{props.param.label}</ParameterLabelV2>
            {props.param.secondaryLabel && (
              <ParameterSecondaryLabelV2>
                {props.param.secondaryLabel}
              </ParameterSecondaryLabelV2>
            )}
          </ParameterLabelStackV2>
          <ParameterControlsV2>
            {(() => {
              const originalValueComponent = getOriginalValueComponent(true)
              const hasUnit = !!props.param?.unit

              return (
                <ParameterControlRowV2>
                  {getInputComponent()}
                  {(hasUnit || originalValueComponent) && (
                    <ParameterUnitAndResetRowV2>
                      {originalValueComponent}
                      {hasUnit && (
                        <ParameterUnitV2>({props.param.unit})</ParameterUnitV2>
                      )}
                    </ParameterUnitAndResetRowV2>
                  )}
                </ParameterControlRowV2>
              )
            })()}
          </ParameterControlsV2>
        </ParameterRowV2>
      )}
    </>
  )
}

export interface AdjustmentParametersProps {
  useLz?: boolean
  parameters?: AdmParameter[]
  tweener: boolean
  isSmall?: boolean
  subText?: string
}

export const AdjustmentParameters = (props: AdjustmentParametersProps) => {
  const { view } = useEvaluationUser()
  const adjustment = useAdjustment()

  const parameters =
    props && props.parameters && adjustment && view ? (
      props.parameters &&
      props.parameters[0] &&
      props.parameters.map((param, index) => {
        if (param.type === 'button' && param.buttonComponent !== undefined) {
          return (
            <>
              <AdmSectionSideItem key={param.adjustmentKey}>
                <AdmSectionSideItemBox>
                  {param.buttonComponent()}
                </AdmSectionSideItemBox>
              </AdmSectionSideItem>
            </>
          )
        }
        if (param.shouldRender) {
          if (param.shouldRender(adjustment, view)) {
            return (
              <>
                <AdmSectionSideItem>
                  <AdmSectionSideItemBox>
                    <AdmParameterItem
                      param={param}
                      lz={props.useLz ? view.shot : undefined}
                    />
                  </AdmSectionSideItemBox>
                </AdmSectionSideItem>

                <AdmSectionSeparator />
              </>
            )
          }
        } else {
          return (
            <>
              <AdmSectionSideItem>
                <AdmSectionSideItemBox>
                  <AdmParameterItem
                    param={param}
                    lz={props.useLz ? view.shot : undefined}
                  />
                </AdmSectionSideItemBox>
              </AdmSectionSideItem>
              <AdmSectionSeparator />
            </>
          )
        }
      })
    ) : (
      <>
        <SideItemSkeleton />
      </>
    )

  return (
    <>
      {props.parameters && props.parameters[0] && (
        <>
          <AdmSectionSideHeader>
            <AdmSectionHeading>Parameters</AdmSectionHeading>
            <AdmSectionSubText>{props.subText}</AdmSectionSubText>
          </AdmSectionSideHeader>
          {parameters}
        </>
      )}
      {(!props || !view) && <OptionalAdjustmentSkeleton />}
      {props.tweener && (
        <>
          <AdmSectionSideHeader>
            <AdmSectionHeading>Optional Adjustment</AdmSectionHeading>
          </AdmSectionSideHeader>
          <AdmSectionSideItem>
            <AdmSectionSideItemBox>
              <Tweener useLz={props.useLz} />
            </AdmSectionSideItemBox>
          </AdmSectionSideItem>
        </>
      )}
    </>
  )
}

type OriginalValueComponentProps = {
  param: AdmParameter
  lockStatus: LockStatus
  setAdjustment: (
    type: AdjustmentTypes,
    view: any,
    key: string,
    id: string,
    value: number
  ) => Promise<void>
  view: any
  currentId?: string | null
  originalValue: number | string
  useV2?: boolean
}

function OriginalValueComponent({
  param,
  lockStatus,
  setAdjustment,
  view,
  currentId,
  originalValue,
  useV2 = false,
}: OriginalValueComponentProps) {
  const adjustments = useAdjustment()
  const [resetting, setResetting] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const canEdit = lockStatus === LockStatus.UNLOCKED

  if (!canEdit || originalValue === '') {
    return null
  }

  const handleResetClick = () => {
    setShowConfirmModal(true)
  }

  const handleConfirmReset = async () => {
    setShowConfirmModal(false)
    setResetting(true)
    setTimeout(() => setResetting(false), 2000)
    await setAdjustment(
      param.format as AdjustmentTypes,
      view,
      param.adjustmentKey as string,
      currentId as string,
      Number(originalValue)
    )
  }

  const handleCancelReset = () => {
    setShowConfirmModal(false)
  }

  const valueWithResetIcon = (
    <>
      <div style={{ width: '100%', height: '50%' }}>
        <span
          style={{
            fontSize: '14px',
          }}
        >{`(${originalValue})`}</span>
      </div>

      <div style={{ width: '100%', height: '50%' }}>
        <Feather name="rotate-ccw" size={12} />
      </div>
    </>
  )

  const spinner = (
    <LoadingContainer>
      <Feather name="loader" size={16} />
    </LoadingContainer>
  )

  if (useV2) {
    return (
      <>
        <ResetAdjustmentGroupV2>
          <ResetAdjustmentValueV2>{`(${originalValue})`}</ResetAdjustmentValueV2>
          <ResetAdjustmentButtonV2
            type="button"
            aria-label={`Reset ${param.label}`}
            onClick={
              !resetting
                ? handleResetClick
                : () => console.log('Invalid action')
            }
            disabled={resetting}
          >
            {resetting ? spinner : <Feather name="rotate-ccw" size={14} />}
          </ResetAdjustmentButtonV2>
        </ResetAdjustmentGroupV2>
        <ResetParameterConfirmationModal
          showModal={showConfirmModal}
          closeModal={handleCancelReset}
          acceptFunction={handleConfirmReset}
          parameterLabel={param.label || ''}
          originalValue={originalValue}
        />
      </>
    )
  }
  return (
    <>
      <ResetAdjustmentButton
        onClick={
          !resetting ? handleResetClick : () => console.log('Invalid action')
        }
      >
        {resetting ? (
          spinner
        ) : (
          <ResetAdjustmentButtonContent>
            {!adjustments || !adjustments.adjustments
              ? spinner
              : valueWithResetIcon}
          </ResetAdjustmentButtonContent>
        )}
      </ResetAdjustmentButton>
      <ResetParameterConfirmationModal
        showModal={showConfirmModal}
        closeModal={handleCancelReset}
        acceptFunction={handleConfirmReset}
        parameterLabel={param.label || ''}
        originalValue={originalValue}
      />
    </>
  )
}
